// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2yqIM","notes":"Notes_notes__W2pVZ","note":"Notes_note__1k67Q","markdown":"Notes_markdown__1HZ5J"};